import { VStack, HStack, Icon } from "@/shared/ui/primitives";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

export const IntroSection = () => {
	const { t } = useTranslation();

	const values = [
		{ icon: "Robot" as const, key: "value1" },
		{ icon: "Control" as const, key: "value2" },
		{ icon: "Action" as const, key: "value3" },
	];

	return (
		<VStack className="w-full gap-[40px]">
			{/* 제목 및 설명 */}
			<VStack className="gap-[16px]">
				<h2 className="text-[1.5rem] md:text-[2.25rem] text-ct-strong font-semibold text-center">
					{t("company.intro.title")}
				</h2>
				<p className="text-lg text-ct-regular font-medium text-center max-w-[700px] whitespace-pre-line">
					{t("company.intro.description")}
				</p>
			</VStack>

			{/* 가치 카드들 */}
			<HStack className="w-full gap-[24px] flex-wrap justify-center">
				{values.map((value, index) => (
					<motion.div
						key={index}
						className="w-full md:w-[340px] flex"
						initial={{ opacity: 0, y: 30 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: true }}
						transition={{ delay: index * 0.15, duration: 0.6 }}
						whileHover={{ y: -8 }}
					>
						<VStack className="gap-[20px] p-[32px] rounded-[16px] bg-bg-regular h-full items-start">
							<div className="flex items-center justify-center w-[56px] h-[56px] rounded-[12px] bg-pm-strong/10">
								<Icon name={value.icon} width={32} height={32} className="text-pm-strong" />
							</div>
							<VStack className="gap-[10px] items-start">
								<h3 className="text-xl text-ct-strong font-semibold">
									{t(`company.intro.${value.key}.title`)}
								</h3>
								<p className="text-md text-ct-regular font-medium">
									{t(`company.intro.${value.key}.description`)}
								</p>
							</VStack>
						</VStack>
					</motion.div>
				))}
			</HStack>
		</VStack>
	);
};
